import Vue from 'vue'
import Vuex from 'vuex'
import role from './modules/role'
import category from './modules/category'
import supplier from './modules/supplier'
import customer from './modules/customer'
import crew from './modules/crew'
import shift from './modules/shift'
import shiftschedule from './modules/shiftschedule'
import training from './modules/training'
import refrigerator from './modules/refrigerator'
import outletrefrigerator from './modules/outletrefrigerator'
import rawmaterial from './modules/rawmaterial'
import variant from './modules/variant'
import reports from './modules/reports'
import menu from './modules/menu'
import misccode from './modules/misccode'
import order from './modules/order'
import production from './modules/production'
import ordercategory from './modules/ordercategory'
import deliveryorder from './modules/deliveryorder'
import stockopname from './modules/stockopname'
import callcenter from './modules/callcenter'
import operationalteam from './modules/operationalteam'
import productcategory from './modules/productcategory'
import outletcategory from './modules/outletcategory'
import coordinator from './modules/coordinator'
import outlet from './modules/outlet'
import vehicle from './modules/vehicle'
import po from './modules/po'
import detailplanning from './modules/detailplanning'
import dailycheck from './modules/dailycheck'
import iseller from './modules/iseller'
import massproduction from './modules/massproduction'
import bantuan from './modules/bantuan'
import tester from './modules/tester'
import pembagiankoordinator from './modules/pembagianKoordinator'
import pembagiankoordinatorlk from './modules/pembagianKoordinatorLK';
import expiredlogistik from './modules/expiredlogistik';
import holiday from './modules/holiday';
import masterdatamenu from './modules/masterdatamenu';
import coordinatorproduction from './modules/coordinatorProduction';
import outletclosing from './modules/outletclosing';
import volumelabel from './modules/volumelabel';

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced: true,  
  modules: {
    role,
    reports,
    category,
    supplier,
    customer,
    crew,
    rawmaterial,
    variant,
    menu,
    misccode,
    order,
    production,
    ordercategory,
    deliveryorder,
    stockopname,
    callcenter,
    operationalteam,
    productcategory,
    outletcategory,
    coordinator,
    outlet,
    vehicle,
    po,
    detailplanning,
    dailycheck,
    iseller,
    training,
    refrigerator,
    outletrefrigerator,
    shift,
    shiftschedule,
    massproduction,
    bantuan,
    tester,
    pembagiankoordinator,
    pembagiankoordinatorlk,
    expiredlogistik,
    holiday,
    masterdatamenu,
    coordinatorproduction,
    outletclosing,
    volumelabel
  },
  state: {
    config: {
      backend: process.env.VUE_APP_ROOT_API + '/',
      apiHost: process.env.VUE_APP_ROOT_API + '/api/v1/',
      mediaHost: process.env.VUE_APP_ROOT_API + '/gallery/',
    },
    token: localStorage.getItem('adm_access_token') || null,
    profile: {},
    snackbar: {
      saveError: false,
      errorMessage: null,
      saveSuccess: false,
      successMessage: null
    },
    currentPagePriv: {}
  },
  getters: {
    loggedIn(state) {
      if (state.token === null || state.token === "undefined") return false
      else return true
    },
  },  
  mutations: {
    setToken(state, token) {
      state.token = token
      localStorage.setItem('adm_access_token', token)
    },
    setProfile(state, payload) {
      state.profile = payload
    },
    removeToken(state) {
      state.token = null
      localStorage.removeItem('adm_access_token')
    },
    setSnackbar(state, payload) {
      state.snackbar.saveError = payload.saveError
      state.snackbar.errorMessage = payload.errorMessage
      state.snackbar.saveSuccess = payload.saveSuccess
      state.snackbar.successMessage = payload.successMessage
    },
    setCurrentPagePriv(state, payload) {
      state.currentPagePriv = payload
    }
  },
  actions: {
    login({state, commit}, payload) {
      return new Promise((resolve, reject) => {
        const url = state.config.apiHost + 'login'

        this._vm.$axios.post(url, JSON.stringify(payload), {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          console.log(response)
            commit('setToken', response.data.data.token)
            commit('setProfile', response.data.data.user)
            resolve(response)
        }, error => {
            reject(error)
        });
      })
    },

    getObjs({rootState}, {apidomain, parameter}){
      return new Promise((resolve, reject) => {
          let url = rootState.config.apiHost + apidomain + parameter
          this._vm.$axios.get(url, {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
          .then (response => {
              resolve(response)
          }, error => {
              reject(error)
          })
      })
    },
    
    getProfile({state, commit}) {
      return new Promise((resolve, reject) => {
        const url = state.config.apiHost + 'profile'
        this._vm.$axios.get(url, {headers: {'Authorization': 'Bearer ' + state.token}})
        .then(response => {
            commit('setProfile', response.data.data)
            resolve(response)
        }, error => {
            reject(error)
        });
      })
    },

  },
})
